// Planned Interconnection Location (PIL) helpers.
//
// PIL data comes from the planned_interconnection_locations table, fetched
// separately from the buses query (see usePlannedInterconnectionLocations)
// and merged onto buses as Bus.plannedMw. A bus is a PIL when it has a
// planned MW value; buses that are not on the region's PIL list have
// plannedMw === undefined.

export const isPil = (plannedMw: number | undefined): boolean =>
    plannedMw !== undefined;

// PIL regions levy a separate GRID-C charge on top of constraint upgrade
// costs, so cost totals shown in the UI are labeled as excluding it.
export const PIL_TOTAL_COST_LABEL = "Total cost (excl. GRID-C)";

export type PilStatus =
    | { kind: "upil" }
    | { kind: "covered" }
    | { kind: "over"; overageMw: number };

export const getPilStatus = (
    plannedMw: number | undefined,
    projectSizeMw: number
): PilStatus => {
    if (plannedMw === undefined) {
        return { kind: "upil" };
    }
    if (projectSizeMw <= plannedMw) {
        return { kind: "covered" };
    }
    return { kind: "over", overageMw: projectSizeMw - plannedMw };
};
